<template>
  <div>
    <div class="mainview relative overflow-hidden py-12 px-4 sm:px-6 lg:px-8">
      <div class="absolute top-0 left-0 transform rotate-45">
        <img src="@/assets/images/satelite-1.png" alt="" class="w-32 opacity-50">
      </div>
      <div class="absolute bottom-1/4 left-0">
        <img src="@/assets/images/block-1-1.png" alt="" class="w-60 opacity-70">
      </div>
      <div class="absolute bottom-0 right-0 top-0">
         <img src="@/assets/images/block-1-2.png" alt="" class="w-full h-full object-cover opacity-30">
      </div>

      <div class="max-w-7xl mx-auto pt-[50px] sm:pt-[100px] min-h-mainBlock relative z-10">
        <h1 class="text-4xl sm:text-5xl md:text-7xl font-bold mb-4 sm:mb-8 text-gray-900">АртМандала</h1>
        <p class="text-lg sm:text-xl mb-6 sm:mb-12 max-w-3xl bg-white bg-opacity-80 p-4 rounded shadow">
          Сайт с уникальным подходом к Мандалам Сети Света. Здесь можно скачать наборы мандал, бесплатно рассчитать паттерн для вашего намерения, обучиться методике построения мандал и создать индивидуальный набор мандал в электронном виде.
        </p>
        <div class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4 mb-12">
          <a href="#sets" @click.prevent="scrollToSection('sets')" class="w-full sm:w-auto">
            <button class="w-full sm:w-auto bg-yellow-400 text-black px-6 py-3 font-semibold rounded hover:bg-yellow-500 transition duration-300 shadow">
              Бесплатные наборы
            </button>
          </a>
          <a href="#pattern-calculator" @click.prevent="scrollToSection('pattern-calculator')" class="w-full sm:w-auto">
            <button class="w-full sm:w-auto bg-white text-black px-6 py-3 font-semibold border border-black rounded hover:bg-gray-100 transition duration-300 shadow">
              Расчет паттерна
            </button>
          </a>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div v-for="(item, index) in featuresItems" :key="index">
            <router-link v-if="item.type === 'route'" :to="item.target" class="block">
              <button class="w-full bg-gray-100 p-4 flex items-center space-x-3 hover:bg-gray-200 transition duration-200 rounded shadow text-left h-full">
                <span class="text-2xl text-yellow-500">★</span>
                <span class="font-medium">{{ item.text }}</span>
              </button>
            </router-link>
            <button v-else-if="item.type === 'scroll'" @click="scrollToSection(item.target)" class="w-full bg-gray-100 p-4 flex items-center space-x-3 hover:bg-gray-200 transition duration-200 rounded shadow text-left h-full">
              <span class="text-2xl text-yellow-500">★</span>
              <span class="font-medium">{{ item.text }}</span>
            </button>
             <div v-else class="bg-gray-100 p-4 flex items-center space-x-3 rounded shadow h-full">
               <span class="text-2xl text-yellow-500">★</span>
               <span class="font-medium">{{ item.text }}</span>
             </div>
          </div>
        </div>
        <div class="mt-12 text-center">
           <button @click="scrollToSection('intro-section')" class="animate-bounce text-gray-500 hover:text-gray-700">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8 mx-auto">
                <path stroke-linecap="round" stroke-linejoin="round" d="m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
              <span class="text-sm">Узнать больше</span>
           </button>
        </div>
      </div>
    </div>

    <div id="intro-section" class="bg-[#F0E9EE] py-16 px-4 sm:px-6 lg:px-8 scroll-mt-20">
      <div class="max-w-7xl mx-auto">
        <div class="flex flex-col lg:flex-row items-center justify-between gap-12">
          <div class="lg:w-1/2">
            <h2 class="text-3xl sm:text-4xl font-bold mb-6 text-gray-900">Мандалы Сети Света - это...</h2>
            <p class="text-lg mb-4 text-gray-700">
              Уникальный метод арт-терапии, который через рисунок позволяет убрать внутренние и неосознаваемые ограничения, активировать скрытые ресурсы человека и привлечь желаемые события в его жизнь.
            </p>
            <p class="text-lg mb-4 text-gray-700">
              Автором метода является австрийский ученый, исследователь, целитель Урсула Иррганг.
            </p>
            <p class="text-lg mb-6 text-gray-700">
              Освоив методику создания Мандал Сети Света, можно самостоятельно решать проблемы и получить желаемые результаты в сфере денег, отношений, здоровья, самореализации, отдыха, исполнения желаний.
            </p>
            <router-link to="/article" class="inline-block">
              <button class="bg-yellow-400 text-black px-8 py-3 font-semibold text-lg rounded hover:bg-yellow-500 transition duration-300 shadow-md">
                Статья о методике
              </button>
            </router-link>
          </div>
          <div class="w-full lg:w-1/2">
             <div class="relative w-full" style="padding-top: 56.25%;">
              <iframe
                class="absolute top-0 left-0 w-full h-full rounded-xl shadow-2xl border border-gray-200"
                src="https://www.youtube.com/embed/Aa9AozFL-kA?si=MBWIgB5oZ4aMtpBn"
                title="Мандалы Сети Света"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe>
            </div>
            <p class="mt-4 text-sm text-gray-600 text-center">Узнайте больше о Мандалах Сети Света в этом видео</p>
          </div>
        </div>
      </div>
    </div>

    <div id="basic-methods" class="bg-white py-16 px-4 sm:px-6 lg:px-8 scroll-mt-20">
      <div class="max-w-7xl mx-auto">
        <h2 class="text-3xl sm:text-4xl font-bold mb-8 text-gray-900">Базовые методы расчета Мандал Света</h2>
        <p class="text-lg mb-8 text-gray-700">Базовые методы включают техники, работающие на:</p>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 class="text-xl font-semibold mb-4 text-yellow-600">✨ Расширение, приумножение, привлечение</h3>
            <p class="text-sm mb-4 text-gray-600">(Метод "Квадрат", метод 6)</p>
            <ul class="space-y-2 text-gray-700">
              <li class="flex items-start"><span class="mr-2 text-yellow-500">✓</span>Как исполнять желания;</li>
              <li class="flex items-start"><span class="mr-2 text-yellow-500">✓</span>Как приумножать, расширять и внедрять положительные привычки, убеждения, сценарии;</li>
              <li class="flex items-start"><span class="mr-2 text-yellow-500">✓</span>Как привлекать желаемые события;</li>
              <li class="flex items-start"><span class="mr-2 text-yellow-500">✓</span>Как визуализировать аффирмации, мантры, молитвы;</li>
              <li class="flex items-start"><span class="mr-2 text-yellow-500">✓</span>Как достигать целей наилучшим образом.</li>
            </ul>
          </div>
          <div>
            <h3 class="text-xl font-semibold mb-4 text-purple-600">✨ Избавление, уменьшение симптомов</h3>
            <p class="text-sm mb-4 text-gray-600">(Метод 1аб, метод 2аб)</p>
             <ul class="space-y-2 text-gray-700">
              <li class="flex items-start"><span class="mr-2 text-purple-500">✓</span>Уменьшить симптомы и устранить первопричины болей и заболеваний;</li>
              <li class="flex items-start"><span class="mr-2 text-purple-500">✓</span>Снизить проявления страхов, обид, вины, тревоги;</li>
              <li class="flex items-start"><span class="mr-2 text-purple-500">✓</span>Освободиться от внутренних блоков и препятствий;</li>
              <li class="flex items-start"><span class="mr-2 text-purple-500">✓</span>Устранить негативное влияние прошлого опыта.</li>
            </ul>
          </div>
          <div>
            <h3 class="text-xl font-semibold mb-4 text-teal-600">✨ Исцеление первопричин</h3>
             <p class="text-sm mb-4 text-gray-600">(Метод 5 аб)</p>
            <ul class="space-y-2 text-gray-700">
              <li class="flex items-start"><span class="mr-2 text-teal-500">✓</span>Найти и исцелить первопричины болезней;</li>
              <li class="flex items-start"><span class="mr-2 text-teal-500">✓</span>Найти и исцелить причины негативных эмоций;</li>
              <li class="flex items-start"><span class="mr-2 text-teal-500">✓</span>Трансформировать первопричины внутренних блоков;</li>
              <li class="flex items-start"><span class="mr-2 text-teal-500">✓</span>Трансформировать ментально-эмоциональные привычки (обижаться, обвинять).</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

     <div id="advanced-methods" class="bg-purple-50 py-16 px-4 sm:px-6 lg:px-8 scroll-mt-20">
      <div class="max-w-7xl mx-auto">
        <h2 class="text-3xl sm:text-4xl font-bold mb-8 text-gray-900">Продвинутые методы расчета Мандал Света</h2>
        <p class="text-lg mb-6 text-gray-700">Продвинутые методы включают техники для более глубокой работы:</p>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
           <div>
             <h3 class="text-xl font-semibold mb-4 text-indigo-600">💫 Области применения:</h3>
             <ul class="space-y-2 text-gray-700 list-disc list-inside">
                <li>Расширение, приумножение, привлечение</li>
                <li>Гармонизация и исцеление</li>
                <li>Защита себя и своего пространства</li>
                <li>Исцеление и трансформация родовых сценариев</li>
                <li>Разрешение сложных проблемных ситуаций</li>
             </ul>
           </div>
           <div>
             <h3 class="text-xl font-semibold mb-4 text-indigo-600">💫 Конкретные методы:</h3>
             <ul class="space-y-1 text-gray-700 columns-2">
                <li>Квадрат 2</li>
                <li>Магический квадрат</li>
                <li>Квадрат 5аб</li>
                <li>Метод 3</li>
                <li>Метод 4</li>
                <li>Метод 8аб</li>
                <li>Шестиугольник</li>
                <li>Шестиугольник подлинный</li>
                <li>Кормовая форма</li>
                <li>Гексагон Звезда</li>
             </ul>
           </div>
        </div>
         <div class="text-center mt-8">
             <button @click="scrollToSection('plans')" class="bg-indigo-600 text-white px-8 py-3 font-semibold text-lg rounded hover:bg-indigo-700 transition duration-300 shadow-md">
               Посмотреть тарифы для создания мандал
             </button>
         </div>
      </div>
    </div>

    <div id="benefits-section" class="bg-white py-16 px-4 sm:px-6 lg:px-8 scroll-mt-20">
      <div class="max-w-7xl mx-auto">
        <div class="flex flex-col lg:flex-row justify-between items-center gap-12">
          <div class="hidden lg:block lg:w-1/3">

            <img src="@/assets/images/image-54.png" alt="Мандала Сети Света" class="w-full max-w-xs mx-auto drop-shadow-lg">
          </div>
          <div class="lg:w-2/3">
            <h2 class="text-3xl sm:text-4xl font-bold mb-8 text-gray-900">Мандалы Сети Света помогают</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 font-inter">
              <div v-for="(benefit, index) in benefits" :key="index" class="flex items-start space-x-3">

                 <span class="flex-shrink-0 w-6 h-6 bg-yellow-300 rounded-full flex items-center justify-center mt-1">
                    <svg class="w-4 h-4 text-yellow-700" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>
                 </span>
                <p class="text-lg text-gray-700">{{ benefit }}</p>
              </div>
            </div>
            <div class="mt-10">

              <a href="https://t.me/OlgaChamina" target="_blank" rel="noopener noreferrer" class="inline-block">
                <button class="bg-purple-600 text-white px-8 py-3 font-semibold text-lg rounded hover:bg-purple-700 transition duration-300 shadow-md flex items-center space-x-2">
                   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5"> <path stroke-linecap="round" stroke-linejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" /> </svg>
                  <span>Заказать индивидуальный набор</span>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="sets" class="bg-gray-100 py-16 px-4 sm:px-6 lg:px-8 scroll-mt-20">
      <div class="max-w-7xl mx-auto">
        <h2 class="text-3xl sm:text-4xl font-bold mb-10 text-center text-gray-900">Бесплатные готовые наборы</h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          <div v-for="(item, index) in mandalaItems" :key="index" class="bg-white rounded-lg shadow-lg overflow-hidden transition-transform duration-300 hover:shadow-xl hover:-translate-y-1 flex flex-col">
            <img :src="item.image" :alt="item.title" class="w-full h-52 sm:h-60 object-cover">
            <div class="p-5 flex flex-col flex-grow justify-between">
              <div>
                <p class="text-base font-medium mb-3 line-clamp-3 h-20">{{ item.title }}</p>


              </div>
              <button
                @click="downloadFile(item.fileUrl)"
                :class="['mt-4 w-full py-2.5 font-semibold rounded transition-colors duration-300 flex items-center justify-center space-x-2', item.buttonColor, 'hover:bg-purple-700 hover:text-white text-black']"
              >
                <ArrowDownTrayIcon class="h-5 w-5" />
                <span>Скачать</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="plans" class="bg-purple-50 py-16 px-4 sm:px-6 lg:px-8 scroll-mt-20">
      <div class="max-w-7xl mx-auto">
        <h2 class="text-3xl sm:text-4xl font-bold text-center mb-4 text-gray-900">Тарифы</h2>
        <p class="text-lg text-gray-600 text-center max-w-2xl mx-auto mb-8">
          Выберите подходящий доступ к автоматической программе создания индивидуальных шаблонов мандал.
        </p>

        <!-- Toggle Switch (Saved for later) -->
        <!--
        <div class="flex justify-center mb-12">
          <div class="bg-white p-1 rounded-xl shadow-sm border border-gray-200 inline-flex">
            <button
              @click="activeTab = 'plans'"
              :class="[
                'px-6 py-2.5 rounded-lg text-sm font-medium transition-all duration-200',
                activeTab === 'plans'
                  ? 'bg-indigo-600 text-white shadow-md'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              ]"
            >
              Подписки
            </button>
            <button
              @click="activeTab = 'packages'"
              :class="[
                'px-6 py-2.5 rounded-lg text-sm font-medium transition-all duration-200',
                activeTab === 'packages'
                  ? 'bg-indigo-600 text-white shadow-md'
                  : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
              ]"
            >
              Пакеты рисунков
            </button>
          </div>
        </div>

        <div v-if="activeTab === 'plans'">
           <Plans :plans="plans" />
        </div>
        <div v-else>
           <DrawingPackages :packages="packages" />
        </div>
        -->

        <!-- Display Packages Only -->
        <DrawingPackages :packages="packages" />
      </div>
    </div>

    <div class="bg-white py-16 px-4 sm:px-6 lg:px-8">
      <div class="max-w-7xl mx-auto">
        <h2 class="text-3xl sm:text-4xl font-bold mb-10 text-center text-gray-900">Вот что думают наши клиенты</h2>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div v-for="review in reviews" :key="review.id" class="bg-gray-50 rounded-lg shadow p-6 border border-purple-100 flex flex-col">
            <div class="flex items-center mb-4">

              <span class="w-10 h-10 rounded-full bg-purple-200 text-purple-700 flex items-center justify-center font-semibold mr-3">{{ review.name.charAt(0) }}</span>
              <h3 class="font-semibold text-lg text-gray-800">{{ review.name }}</h3>
            </div>
            <p class="text-gray-600 mb-4 flex-grow">
              {{ review.expanded ? review.fullText : review.text }}
              <span v-if="!review.expanded && review.fullText.length > review.text.length">...</span>
            </p>

            <button
              v-if="review.fullText.length > review.text.length"
              @click="toggleReview(review)"
              class="text-purple-600 font-semibold hover:text-purple-800 transition-colors duration-200 mt-auto text-left self-start"
            >
              {{ review.expanded ? 'Свернуть' : 'Читать полностью' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div id="pattern-calculator" class="bg-[#F0E9EE] py-16 px-4 sm:px-6 lg:px-8 scroll-mt-20">
      <div class="max-w-4xl mx-auto">
         <h2 class="text-3xl sm:text-4xl font-bold mb-10 text-center text-gray-900">Рассчитать паттерн</h2>
          <div class="calculator-container bg-white p-6 sm:p-10 rounded-xl shadow-xl border border-gray-200">
            <PatternCalculator :embedded="true" />
          </div>
      </div>
    </div>

    <!-- Support Bot Widget -->
    <div class="fixed bottom-4 right-4 z-50 flex items-center gap-2">
      <a
        href="https://t.me/Artmandalabot"
        target="_blank"
        rel="noopener noreferrer"
        class="flex items-center justify-center gap-2 px-4 py-2 bg-blue-500 rounded-full shadow-lg hover:bg-blue-600 transition-all duration-300"
        aria-label="Написать в поддержку"
      >
        <svg class="w-6 h-6 text-white" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.161l-1.97 9.293c-.146.658-.537.818-1.084.508l-3-2.211-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12l-6.871 4.326-2.962-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.832.929z"/>
        </svg>
        <span class="text-sm font-semibold text-white whitespace-nowrap">Поддержка</span>
      </a>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router'; // Import useRouter
import axiosInstance from '@/axios/axios';
import { Dialog, DialogPanel, DialogTitle, TransitionRoot } from '@headlessui/vue';
import { CheckIcon, ArrowDownTrayIcon } from '@heroicons/vue/24/outline';
import PatternCalculator from '@/components/Testcalc.vue';
import Plans from '@/components/Plans.vue';
import DrawingPackages from '@/components/DrawingPackages.vue';

// --- Image and File Imports ---
// (Keep your existing imports for images and files)
import cardImage1 from '@/assets/images/card-1.png';
import cardImage2 from '@/assets/images/card-2.png';
import cardImage3 from '@/assets/images/card-3.png';
import cardImage4 from '@/assets/images/card-4.png';
import cardImage5 from '@/assets/images/card-5.png';
import cardImage6 from '@/assets/images/card-6.png';
import cardImage7 from '@/assets/images/card-7.png';
// import personImage1 from '@/assets/images/person-1.png';
// import personImage2 from '@/assets/images/person-2.png';
// import personImage3 from '@/assets/images/person-3.png';

import mandalSet1 from '@/assets/files/artmandala.live_set_1.pdf';
import mandalSet2 from '@/assets/files/artmandala.live_set_2.pdf';
import mandalSet3 from '@/assets/files/artmandala.live_set_3.pdf';
import mandalSet4 from '@/assets/files/artmandala.live_set_4.pdf';
import mandalSet5 from '@/assets/files/artmandala.live_set_5.pdf';
import mandalSet6 from '@/assets/files/artmandala.live_set_6.pdf';
import mandalSet7 from '@/assets/files/artmandala.live_set_7.pdf';
// --- End Imports ---

const router = useRouter(); // Initialize router

// --- State ---
const plans = ref([]);
const packages = ref([]);
const activeTab = ref('plans'); // 'plans' or 'packages'

const reviews = ref([ // Shorten initial text for better 'Read More' effect
  { id: 1, name: 'Анна С.', text: 'Узнала о курсе Ольги и сразу решила его пройти. Я была знакома с этим методом раньше, но не встречала того, кто мог бы обучить...', fullText: 'Узнала о курсе Ольги и сразу решила его пройти. Я была знакома с этим методом раньше, но не встречала того, кто мог бы обучить ему. Преподносилось, как эксклюзивное знание.В курсе Ольга дала такой большой объем информации и методов, что его оказалось мне больше, чем достаточно. Ольга подаёт материал курса структурно, понятно и в комплексе с теорией много практики За время курса я взяла одно намерение и ещё на этапе прорисовки препятствий уже получила результаты. К моменту окончания мандалы на позитивное намерение, оно уже почти осуществилось. Я выбрала новую квартиру))) Мне очень понравилось, что Ольга предлагала несколько вариантов изучения. Я выбрала самостоятельно изучать. При этом, Ольга отвечала на все мои вопросы, сопровождала все время, пока я доходила до конца. А это оказалось дольше, чем 10 недель. Очень благодарна Ольге за такое внимание  И ещё: я покупала курс вместе с программой. Очень советую этот пакет. Зная сам метод, программа помогает облегчить некоторые задачи, особенно, если делать мандалы клиентам Ольга, Благодарю за такой труд в создании курса и поддержку во время обучения. ', expanded: false },
  { id: 2, name: 'Михаил Д.', text: 'Удобный интерфейс и широкие возможности. Я новичок в создании мандал, но благодаря этой программе смог быстро освоиться...', fullText: 'Удобный интерфейс и широкие возможности. Я новичок в создании мандал, но благодаря этой программе смог быстро освоиться. Видеоинструкции очень помогли разобраться во всех тонкостях. Особенно впечатлили продвинутые методы создания мандал. Теперь это мое любимое хобби!', expanded: false },
  { id: 3, name: 'Елена В.', text: 'Очень довольна курсом. Материал подается структурированно и понятно. Ольга отвечает на все вопросы и всегда готова помочь...', fullText: 'Очень довольна курсом. Материал подается структурированно и понятно. Ольга отвечает на все вопросы и всегда готова помочь. Благодаря курсу я не только научилась создавать красивые мандалы, но и глубже поняла их значение в медитативных практиках. Это был увлекательный journey самопознания!', expanded: false }
]);

// --- Data ---
const benefits = [
  'Исполнить желания и приблизить желаемые события',
  'Исцелить и трансформировать различные страхи',
  'Увеличить доход и привлечь изобилие в свою жизнь',
  'Гармонизировать отношения с собой, партнером, близкими', // Simplified
  'Освободить и трансформировать негативные чувства и эмоции', // Simplified
  'Укрепить связь с родом и трансформировать родовые программы'
];

const mandalaItems = [
  { image: cardImage1, title: 'Набор мандал «Все перемены в моей жизни происходят своевременно и по наилучшему»', buttonColor: 'bg-yellow-400', fileUrl: mandalSet1 },
  { image: cardImage2, title: 'Набор мандал «Ко мне легко приходят деньги на все мои желания, мечты и цели»', buttonColor: 'bg-yellow-400', fileUrl: mandalSet2 },
  { image: cardImage3, title: 'Набор мандал «Мой денежный поток увеличивается каждый месяц»', buttonColor: 'bg-yellow-400', fileUrl: mandalSet3 },
  { image: cardImage4, title: 'Набор мандал «Счастье каждого дня моей жизни»', buttonColor: 'bg-yellow-400', fileUrl: mandalSet4 },
  // { image: cardImage5, title: 'Набор мандал «Я благодарна Богу за моих детей»', buttonColor: 'bg-yellow-400', fileUrl: mandalSet5 },
  // { image: cardImage6, title: 'Набор мандал «Я и мои близкие под защитой Высших сил»', buttonColor: 'bg-yellow-400', fileUrl: mandalSet6 },
  // { image: cardImage7, title: 'Набор мандал «Я выстраиваю теплые, доверительные, наполненные любовью отношения»', buttonColor: 'bg-yellow-400', fileUrl: mandalSet7 }, // Shortened
];

// ===== UPDATED: Features Items with Actions =====
const featuresItems = ref([
  { text: 'Базовые методики', type: 'scroll', target: 'basic-methods' },
  { text: 'Программа создания мандал', type: 'route', target: '/register' }, // Use 'route' type
  { text: 'Продвинутые методики', type: 'scroll', target: 'advanced-methods' },
  { text: 'Индивидуальный набор мандал', type: 'scroll', target: 'benefits-section' }, // Scroll to benefits where the order button is
  { text: 'Бесплатные наборы', type: 'scroll', target: 'sets' },
  { text: 'Расчет паттерна', type: 'scroll', target: 'pattern-calculator' }
]);

// --- Methods ---

// Smooth Scrolling Function
const scrollToSection = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
     // Optional: Update URL hash without page jump (for better UX)
     // history.pushState(null, null, `#${id}`);
  } else {
      console.warn(`Element with ID "${id}" not found for scrolling.`);
      // As a fallback for register, if it wasn't handled by router-link
      if (id === '/register') {
          router.push('/register');
      }
  }
};


// Fetch Plans (Keep as is)
const fetchPlans = async () => {
  try {
    const response = await axiosInstance.get('/draw/api/v1/free/plans/details')
    plans.value = response.data
  } catch (error) {
    console.error('Error fetching subscription plans:', error)
    // Provide fallback or default plans if needed
    // plans.value = [ { name: 'Базовый', ... }, ... ];
  }
}

const fetchPackages = async () => {
  try {
    const response = await axiosInstance.get('/draw/api/v1/free/packages/')
    packages.value = response.data
  } catch (error) {
    console.error('Error fetching drawing packages:', error)
  }
}

// Modal Logic (Keep as is)
const showDetails = (plan) => {
  selectedPlan.value = plan
  isModalOpen.value = true
}
const closeModal = () => {
  isModalOpen.value = false
  selectedPlan.value = null // Reset selected plan
}
const getBulletPoints = (bulletPointsText) => {
  if (!bulletPointsText) return [];
  return bulletPointsText.split('\n').map(p => p.trim()).filter(point => point);
}

// Download File (Keep as is)
const downloadFile = (fileUrl) => {
  if (!fileUrl) {
      console.error("No file URL provided for download.");
      // Optionally show a user-friendly error message
      alert("Файл для скачивания не найден.");
      return;
  }
  const link = document.createElement('a');
  link.href = fileUrl;
  // Create a more user-friendly filename if possible
  const filename = fileUrl.split('/').pop().replace(/_/g, ' ');
  link.download = filename || 'mandala-set.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Toggle Review Expansion (Keep as is)
const toggleReview = (review) => {
  review.expanded = !review.expanded;
};

// --- Lifecycle Hooks ---
onMounted(() => {
  // fetchPlans(); // Saved for later
  fetchPackages();
   // Optional: Handle scrolling if URL has a hash on initial load
  if (window.location.hash) {
      const id = window.location.hash.substring(1);
      // Use setTimeout to ensure the element is rendered
      setTimeout(() => scrollToSection(id), 100);
  }
});

</script>

<style scoped>
/* Add smooth scrolling behavior to the root element */
html {
  scroll-behavior: smooth;
}

/* Add scroll-margin-top to relevant sections if you have a fixed header */
/* Example: Adjust the value (e.g., 5rem) based on your header's height */
/*
#intro-section, #basic-methods, #advanced-methods, #benefits-section, #sets, #plans, #pattern-calculator {
  scroll-margin-top: 5rem;
}
*/

.clip-octagon {
  clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
}

/* Subtle bounce animation */
@keyframes bounce {
  0%, 100% {
    transform: translateY(-15%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: translateY(0);
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}
.animate-bounce {
  animation: bounce 1.5s infinite;
}

/* Add any other specific styles you need */
.min-h-mainBlock {
  min-height: calc(100vh - 150px); /* Adjust 150px based on header/footer height */
}
</style>
